const Edicuate = function() {
    function Edicuate() {
        this.selector = {
            counters: document.querySelectorAll(".counter")
        }
        this.state = {
            counts: null,
            upto: 0
        }
        this.load();
    }
    Edicuate.prototype.load = function() {
        var _ = this;
        document.addEventListener("DOMContentLoaded", () => {
            _.selector.counters.forEach((el, index) => {
                    const target = parseInt(el.getAttribute('data-target'));
                    let count = 0;
                    const speed = Math.floor(target / 50);   
                    const updateCounter = () => {                        
                        const increment = target / speed;   
                        console.log(increment);                 
                        if (count < target) {
                            count += increment;
                            el.textContent = Math.ceil(count);
                            requestAnimationFrame(updateCounter);
                        } else {
                            el.textContent = target;
                        }
                    };                    
                    updateCounter();                    
            })
        })      
    }
    Edicuate = new Edicuate;
}

Edicuate();
